import type {
    MembershipProfileAnswer,
    MembershipProfileAnswerUpsertDto,
    ProfileAnswer,
} from '@fruitful/member-profile';

import { requestBuilder } from '../../http/RequestBuilder';

const useUpsertMembershipProfileAnswer = requestBuilder.mutation<
    Array<MembershipProfileAnswer<ProfileAnswer>>,
    Array<MembershipProfileAnswerUpsertDto<ProfileAnswer>>,
    { membershipId: string }
>({
    endpoint: (urlParams) =>
        `/api/admin/membership-profile/answer/${urlParams.membershipId}`,
    method: 'POST',
});

export default useUpsertMembershipProfileAnswer;
